import {
  Typography,
} from '@mui/material';
import { filterUndefined } from '../../utils/FilterUndefinedObject';
import './NoLessonPaper.scss';

/**
 * Paper card for display No lesson available.
 */
const defaultProps = {
  message: 'No Activities Available',
  className: '',
};
export default function NoLessonPaper(props) {
  const { message, className } = { ...defaultProps, ...filterUndefined(props) };
  return (
    <div className={`no-lesson-container ${className}`} data-test='no-lesson'>
      <Typography component='p' className='no-lesson-container-message' data-private>
        {message}
      </Typography>
    </div>
  );
}
